<template lang="pug">
  b-dropdown(dropdown)
    template(slot="button-content")
      span
    b-dropdown-item-button(@click="set(row)" v-for="(row, index) in data" :key="index" :class="{ 'selected': row.value == selected }") {{ row.name }}
</template>

<script>
export default {
  name: 'b-chart-type',
  props: ['value', 'data'],
  data() {
    return {
      selected: null,
    }
  },
  methods: {
    set(data) {
      this.selected = data.value
      this.$emit('input', this.selected)
    },
  },
  mounted() {
    this.selected = this.$props.value
    if (!this.selected) {
      let def = this.$props.data.filter(row => row.default)
      this.set(def.length > 0 ? def[0] : this.$props.data[0])
    }
  }
};
</script>


// WEBPACK FOOTER //
// chart_type.vue